import {
  AlertTriangle,
  BarChart3,
  Clock,
  Database,
  FlaskConical,
  PenLine,
  type LucideIcon,
} from "lucide-react";

export interface EmptyStatePreset {
  label: string;
  prompt: string;
  icon: LucideIcon;
}

export const EMPTY_STATE_PRESETS: EmptyStatePreset[] = [
  {
    label: "Analytics dashboard",
    icon: BarChart3,
    prompt:
      "Create a custom analytics view for the last 30 days that compares cost by model over time, p95 latency by provider, and cached vs thinking tokens by provider.",
  },
  {
    label: "Create an eval",
    icon: FlaskConical,
    prompt:
      "Help me create an evaluation to test my prompt quality. Walk me through picking a dataset and a scoring method, then set it up.",
  },
  {
    label: "Dataset from logs",
    icon: Database,
    prompt:
      "Create a dataset from my recent request logs so I can use it for evaluations and regression testing.",
  },
  {
    label: "Draft a prompt",
    icon: PenLine,
    prompt:
      "Help me draft a new prompt template with input variables, following prompt engineering best practices.",
  },
  {
    label: "Find slow requests",
    icon: Clock,
    prompt:
      "Show me the slowest requests from the last 7 days and summarize what they have in common.",
  },
  {
    label: "Summarize errors",
    icon: AlertTriangle,
    prompt: "Summarize recent failed requests and group them by error type.",
  },
];
